<div
  class="fixed top-4 right-4 z-[9999] flex flex-col gap-3 w-[360px] max-w-[calc(100vw-2rem)]"
>
  @for (msg of toastService.messages(); track msg.id) {
  <div
    @toastAnim
    class="relative flex items-start gap-3 rounded-[18px] px-4 py-3.5 overflow-hidden glass-card backdrop-blur-[20px] border border-white/40 dark:border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.08),0_1px_0_rgba(255,255,255,0.5)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.4)]"
  >
    <!-- Icon -->
    <div
      class="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
      [class]="colors[msg.severity].bg"
    >
      <span
        class="material-symbols-outlined !text-[18px]"
        [class]="colors[msg.severity].icon"
        >{{ icons[msg.severity] }}</span
      >
    </div>

    <!-- Text -->
    <div class="flex flex-col gap-0.5 min-w-0 flex-1 pt-0.5">
      <span
        class="text-[13px] font-semibold text-slate-800 dark:text-cream-100 leading-snug"
        >{{ msg.summary }}</span
      >
      <span class="text-[12px] text-slate-500 dark:text-slate-400 leading-snug"
        >{{ msg.detail }}</span
      >
    </div>

    <!-- Close button -->
    <button
      type="button"
      class="shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-slate-400 hover:text-slate-600 dark:hover:text-cream-100 hover:bg-black/5 dark:hover:bg-white/10 transition-colors cursor-pointer"
      (click)="toastService.dismiss(msg.id)"
    >
      <span class="material-symbols-outlined !text-[18px]">close</span>
    </button>

    <!-- Progress bar -->
    <div
      class="absolute bottom-0 left-0 right-0 h-[2px] bg-black/[0.04] dark:bg-white/[0.06]"
    >
      <div
        class="h-full rounded-full opacity-60"
        [class]="colors[msg.severity].accent"
        [style.animation]="'toast-progress ' + msg.life + 'ms linear forwards'"
      ></div>
    </div>
  </div>
  }
</div>
